// Online-mode switch (ADR 0040 P6-5, plan §2.1): the client is wired to the
// real API ONLY when VITE_API_BASE_URL is set at build/dev time. Unset (the
// default, and always in vitest) keeps the fully-offline local-mock paths —
// existing behaviour and tests are untouched. All env access lives here so
// components never read import.meta.env directly.

export function apiBaseUrl(): string | null {
  const value = import.meta.env.VITE_API_BASE_URL as string | undefined;
  if (value === undefined || value.length === 0) return null;
  return value.replace(/\/+$/u, '');
}

export function isOnline(): boolean {
  return apiBaseUrl() !== null;
}
